<template>
    <div class="wishlist-list-page">
        <template v-if="isWishlistLoading">
            <div class="wishlist-list-page__list-loader">
                <svg>
                    <use xlink:href="#wishlist-list-skeleton"></use>
                </svg>
            </div>
        </template>

        <template v-else>
            <div class="wishlist-list-page__nav-section">
                <!-- Breadcrumb -->
                <nav aria-label="Breadcrumb" class="wishlist-list-page__nav-section-breadcrumb">
                    <ol>
                        <li><a href="/">Home</a></li>
                        <li aria-current="page">Wishlists</li>
                    </ol>
                </nav>
            </div>

            <!-- Heading -->
            <h3 class="wishlist-list-page__title">Your Saved Wishlists</h3>

            <!-- List cards rendering for each list -->
            <div v-if="wishlistContentDetailsList.length > 0" class="wishlist-list-page__list-container">
                <ListCard
                    v-for="listItem in wishlistContentDetailsList"
                    :listDetails="listItem"
                    :handleListCardClick="handleListCardClick"
                />
            </div>

            <div v-else class="wishlist-list-empty-page">
                <p class="wishlist-list-empty-page__message">It looks like you don't have any wishlists at the moment but that's a perfect chance to start one!</p>
                <p v-if="!isAuthUser" class="wishlist-list-empty-page__signin">
                    <button class="btn wishlist-list-empty-page__signin-cta" @click="handleSignIn">Sign in</button>
                    or
                    <button class="btn wishlist-list-empty-page__signin-cta" @click="handleCreateAccount">Create account</button>
                    to be able to save your wishlists
                </p>
                <button
                    class="btn btn--secondary btn--medium wishlist-list-empty-page__continue-shopping"
                    @click="handleContinueShopping"
                >
                    CONTINUE SHOPPING
                </button>
            </div>
        </template>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import ListCard from './list-card.vue';

const props = defineProps({
    showWishlistContentPage: {
        type: Function,
        default: () => { }
    },
});

const store = useStore();

const isWishlistLoading = computed(() => store.state.isWishlistLoading);
const wishlistContentDetailsList = computed(() => store.state.wishlistContentDetailsList);
const isAuthUser = computed(() => {
    const customerDetails = window?.getCustomerDetails?.();
    if (customerDetails) {
        return true;
    }

    return false;
});

const handleListCardClick = (listDetails) => {
    store.dispatch('setSelectedWishlistDetails', listDetails);
    props.showWishlistContentPage(true, listDetails?.lid);
};

const handleContinueShopping = () => {
    window.location.href = '/';
};

const handleCreateAccount = () => {
    const returnToUrl = window.location.href;
    const registerUrl = `/account/register?return_to=${encodeURIComponent(returnToUrl)}`;
    // Redirect the user
    window.location.href = registerUrl;
};

const handleSignIn = () => {
    const returnToUrl = window.location.href;
    const loginUrl = `/account/login?return_to=${encodeURIComponent(returnToUrl)}`;
    // Redirect the user
    window.location.href = loginUrl;
};
</script>